/* globals $, data, query_string */
import 'highcharts/highcharts'

if (query_string.challenger) {
    $('#challenger').val(query_string.challenger).attr('selected', true)
    $('#lblChallenger').html($('#challenger option:selected').text())
}

if (query_string.challenge_type) {
    $('#challenge_type').val(query_string.challenge_type).attr('selected', true)
    $('#lblChallengeType').html($('#challenge_type option:selected').text())
}

if (query_string.year) {
    $('#year').val(query_string.year).attr('selected', true)
    $('#lblYear').html($('#year option:selected').text())
}

if (query_string.team) {
    $('#team').val(query_string.team).attr('selected', true)
    $('#lblTeam').html($('#team option:selected').text())
}

$('.form-control').change(({ target }) => {
    // This is all to change the label as the page reloads
    const { id, selectedIndex } = target
    const labelId = findLabel(id)
    const $label = document.getElementById(labelId)
    $label.innerText = target[selectedIndex].text

    window.location = `replay?challenge_type=${$(
        '#challenge_type'
    ).val()}&year=${$('#year').val()}&challenger=${$(
        '#challenger'
    ).val()}&team=${$('#team').val()}`
})

// Solving a problem nobody cares about. Switching the label as the page reloads
function findLabel(id) {
    // convert to camelcase
    const words = id.split('_')
    const upperWords = words.map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    const upperCamelCase = upperWords.join('')

    return `lbl${upperCamelCase}`
}

$(document).ready(() => {
    if (!data.length) {
        return
    }

    const qs = window.location.search.substring(1)
    fetch(`/leaderboard/replay/breakdown?${qs}&type=${$('#challenger').val()}`)
        .then((res) => res.json())
        .then(
            ({
                overturned,
                challengedGroup,
                challengingGroup,
                hasTeam,
                isChallenged,
                challengeType,
                teams,
            }) => {
                const teamMap = teams.reduce((acc, curr) => {
                    acc[curr.team_id] = curr
                    return acc
                }, {})

                // Determine whether to show challenged/challenging group
                const groupIsChallenged = hasTeam ? !isChallenged : isChallenged
                const group = groupIsChallenged
                    ? challengedGroup
                    : challengingGroup

                const challengers = group.map((item) => {
                    const { team_name, parent_color } =
                        teamMap[item.team_id] || {}

                    return {
                        name: team_name || 'Umpire',
                        y: item.count,
                        color: parent_color ? `#${parent_color}` : '#000',
                    }
                })

                const overturnedData = overturned.map((item) => ({
                    name: item.is_overturned ? 'Overturned' : 'Not Overturned',
                    y: item.count,
                    color: item.is_overturned ? '#629632' : '#C80000',
                }))

                const typeData = challengeType.map((item) => ({
                    name: item.review_description,
                    y: item.count,
                }))

                if (hasTeam && isChallenged) {
                    createPie('challengers', 'Challenging Team', challengers)
                } else if (hasTeam && !isChallenged) {
                    createPie('challengers', 'Challenged Team', challengers)
                } else if (isChallenged) {
                    createPie('challengers', 'Challenged Team', challengers)
                } else {
                    createPie('challengers', 'Challenging Team', challengers)
                }

                createPie('overturned', 'Overturned', overturnedData)
                createPie('challenge_types', 'Challenge Types', typeData)
            }
        )
})

function createPie(id, title, data) {
    $(`#${id}`).highcharts({
        credits: {
            enabled: false,
        },
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
        },
        title: {
            text: title,
        },
        tooltip: {
            shared: false,
            useHTML: true,
            formatter() {
                return `<div style="font-weight: bold; font-size: 14px;">${
                    this.point.name
                }</div><div style="font-size: 14px; width: 150px; white-space: normal">Total: ${
                    this.point.y
                } (${parseFloat(
                    Math.round(this.point.percentage * 100) / 100
                ).toFixed(2)}%)</div>`
            },
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false,
                    color: '#000000',
                    connectorColor: '#000000',
                },
            },
        },
        series: [
            {
                type: 'pie',
                name: 'Team',
                data,
            },
        ],
    })
}
